import { type Dispatch, type SetStateAction, useState } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
    AnalyticsContentModalOptions,
    AnalyticsContentModalSortDirections,
    AnalyticsContentModalSortTabs
} from 'components-ref/molecules/analytics'
import { Modal } from 'components-ref/molecules/modal/modal'
import colors from 'styles/colors'
import { type SortDirection } from 'types/enums'
import { Tabs } from 'types/enums/analytics/content/sort/Tabs'
import {
    type AnalyticsContentModalSortBy,
    type ContentModalSortFilter
} from 'types/interfaces/IContentModalSortFilter'

interface AnalyticsContentSortModalProps {
    sort: ContentModalSortFilter
    setSort: Dispatch<SetStateAction<ContentModalSortFilter>>
    activeTab?:any,
    onClose: () => void
}

export const AnalyticsContentSortModal = ({
    sort,
    setSort,
    onClose,
    activeTab
}: AnalyticsContentSortModalProps) => {
    const [selectedSort, setSelectedSort] =
        useState<ContentModalSortFilter>(sort)
    const [tab, setTab] = useState<Tabs>(Tabs.SALES)
    const { t } = useTranslation()

    const handleApply = () => {
        setSort(selectedSort)
        onClose()
    }

    const setSortBy = (option: AnalyticsContentModalSortBy | '') => {
        setSelectedSort(prev => {
            return {
                sort_value: prev.sort_value,
                sort_by: option
            }
        })
    }

    const setSortValue = (option: SortDirection | '') => {
        setSelectedSort(prev => {
            return {
                sort_value: option,
                sort_by: prev.sort_by
            }
        })
    }

    return (
        <Modal
            title={t('sortBy')}
            onClose={onClose}
            hasShadow={true}
            isLayerTransparent={false}
            maxWidth={40}
        >
            <Container>
                <AnalyticsContentModalSortTabs tab={tab} setTab={setTab} />
                <AnalyticsContentModalOptions
                    tab={tab}
                    sortByValue={selectedSort.sort_by}
                    setSortBy={setSortBy}
                    activeTab={activeTab}
                />
                <AnalyticsContentModalSortDirections
                    sortValue={selectedSort.sort_value}
                    setSortValue={setSortValue}
                />
                <Apply onClick={handleApply}>{t('apply')}</Apply>
            </Container>
        </Modal>
    )
}

const Container = styled.div`
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
`

const Apply = styled.button`
    border-radius: 1.6rem;
    padding: 0.9rem 5rem;
    background: ${colors.black157deg};
    border: 0;
    margin: 1.2rem auto;
    margin-top:3rem;

    color: ${colors.white};
    font-size: 14px;
    font-weight: 400;
    line-height: 17.07px;
    text-align: center;
    cursor: pointer;

    &:hover {
        opacity: 90%;
    }
`
